import { useState, useEffect, useContext } from 'react'
import { format } from 'react-string-format'
import { Box, Grid, Paper, Typography } from '@material-ui/core'
import { useConfirm } from 'material-ui-confirm'
import validURL from 'valid-url'
import { Context } from '../../../utils/context'
import { Strings } from '../../../assets/res/en'
import { groupsEndPoints, merchantsEndPoints, promotionsEndPoints } from '../../../utils/endpoints'
import useTableIcons from '../../useTableIcons'
import useStyles from '../../useStyles'
import useCommonMenus from '../common/useCommonMenus'
import { toBase64, modules } from '../../../utils/config'

let isEndDateTimeDisabled = true
let MinEndDateTime = null
let ChosenStartDateTime = null
const usePromotions = () => {
    const { axios, authData, permissions } = useContext(Context)
    const { tableIcons } = useTableIcons()
    const authToken = `Bearer ${authData.token}`
    const confirm = useConfirm()
    const classes = useStyles()
    const [promotions, setPromotions] = useState([])
    const [promotionPermission, setPromotionPermission] = useState({})
    const [spromotions, setSearchPromotions] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [searchGroupsMenus, setSearchGroupMenus] = useState([])
    const [searchLocationMenus, setSearchLocationMenus] = useState([])
    const [filters, setFilters] = useState([])
    const [openDialog, setOpenDialog] = useState(false)
    const [modalHeader, setModalHeader] = useState({})
    const [modalContent, setModalContent] = useState({})
    const [modalActions, setModalActions] = useState([])
    const [modalFormResetKeys, setModalFormResetKeys] = useState([])
    const [modalTaskRunning, setModalTaskRunning] = useState(false)
    const [modalFormError, setModalFormError] = useState({})
    const { groupsMenus, locationMenus, setGLObj } = useCommonMenus(axios)
    const [searchData, setSearchData] = useState({
        sTitle: "",
        sGroup: '',
        sLocation: '',
        sStartDateTime: null,
        sEndDateTime: null
    })
    //check permission changes
    useEffect(() => {
        if (permissions && permissions.length > 0) {
            let promoPermission = permissions.find(p => p.moduleId === modules.promotions.id)
            setPromotionPermission(promoPermission)
        }
    }, [permissions])
    //get Groups
    useEffect(() => {
        axios.get(groupsEndPoints.getAll,
            { headers: { 'Authorization': authToken } })
            .then(res => {
                if (res.data.success) {
                    const { data } = res.data
                    const groupItems = data.map(g => ({
                        text: g.description,
                        val: g.idGroup
                    })).sort((a, b) => (a.text ?? "").localeCompare(b.text ?? ""))
                    setSearchGroupMenus([
                        {
                            text: Strings.SEARCH_CASINO_GROUP,
                            val: ''
                        },
                        {
                            text: Strings.NO_GROUP,
                            val: 0
                        },
                        ...groupItems
                    ])
                }
            })
            .catch(err => err)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    //get Locations On Group Chnage
    useEffect(() => {
        setSearchLocationMenus([
            {
                text: Strings.SEARCH_CASINO_LOCATION,
                val: ''
            },
            {
                text: Strings.NO_LOCATION,
                val: 0
            },
        ])
        setSearchData(prevData => ({
            ...prevData,
            sLocation: ''
        }))
        if (searchData.sGroup > 0) {
            let merchantByGroupId = `${merchantsEndPoints.getMerchantByGroupID}/${searchData.sGroup}`
            axios.get(merchantByGroupId,
                { headers: { 'Authorization': authToken } })
                .then(res => {
                    if (res.status === 200) {
                        const { data } = res.data
                        const locationItems = data.map(g => ({
                            text: g.description,
                            val: g.idMerchant
                        })).sort((a, b) => (a.text ?? "").localeCompare(b.text ?? ""))
                        setSearchLocationMenus(prevData => [
                            ...prevData,
                            ...locationItems
                        ])
                    }
                })
                .catch(err => err)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchData.sGroup])

    const clearFilter = ({ name }, nfilters, searchData) => {
        let filteredData = spromotions
        //#region filter data
        switch (name) {
            case "sTitle":
                if (searchData["sGroup"] !== '' && searchData["sGroup"] >= 0)
                    filteredData = filteredData.filter(u => u.idGroup === searchData["sGroup"])
                if (searchData["sLocation"] !== '' && searchData["sLocation"] >= 0)
                    filteredData = filteredData.filter(u => u.idMerchant === searchData["sLocation"])
                if (searchData["sStartDateTime"])
                    filteredData = filteredData.filter(u => +new Date(u.dateTimeStart) >= +new Date(searchData["sStartDateTime"]))
                if (searchData["sEndDateTime"])
                    filteredData = filteredData.filter(u => +new Date(u.dateTimeEnd) <= +new Date(searchData["sEndDateTime"]))
                break;
            case "sGroup":
                if (searchData["sTitle"] && searchData["sTitle"].trim() !== '')
                    filteredData = filteredData.filter(u => u.name.toLowerCase().includes(searchData["sTitle"].trim().toLowerCase()))
                if (searchData["sStartDateTime"])
                    filteredData = filteredData.filter(u => +new Date(u.dateTimeStart) >= +new Date(searchData["sStartDateTime"]))
                if (searchData["sEndDateTime"])
                    filteredData = filteredData.filter(u => +new Date(u.dateTimeEnd) <= +new Date(searchData["sEndDateTime"]))
                const finr = nfilters.filter(f => f.name !== 'sGroup' || f.name !== 'sLocation')
                const fir = nfilters.find(f => f.name === 'sLocation')
                fir.value = ""
                setFilters([fir, ...finr])
                setSearchData(prevData => ({
                    ...prevData,
                    sLocation: ''
                }))
                break;
            case "sLocation":
                if (searchData["sTitle"] && searchData["sTitle"].trim() !== '')
                    filteredData = filteredData.filter(u => u.name.toLowerCase().includes(searchData["sTitle"].trim().toLowerCase()))
                if (searchData["sGroup"] !== '' && searchData["sGroup"] >= 0)
                    filteredData = filteredData.filter(u => u.idGroup === searchData["sGroup"])
                if (searchData["sStartDateTime"])
                    filteredData = filteredData.filter(u => +new Date(u.dateTimeStart) >= +new Date(searchData["sStartDateTime"]))
                if (searchData["sEndDateTime"])
                    filteredData = filteredData.filter(u => +new Date(u.dateTimeEnd) <= +new Date(searchData["sEndDateTime"]))
                break;
            case "sStartDateTime":
                if (searchData["sTitle"] && searchData["sTitle"].trim() !== '')
                    filteredData = filteredData.filter(u => u.name.toLowerCase().includes(searchData["sTitle"].trim().toLowerCase()))
                if (searchData["sGroup"] !== '' && searchData["sGroup"] >= 0)
                    filteredData = filteredData.filter(u => u.idGroup === searchData["sGroup"])
                if (searchData["sLocation"] !== '' && searchData["sLocation"] >= 0)
                    filteredData = filteredData.filter(u => u.idMerchant === searchData["sLocation"])
                const finrDT = nfilters.filter(f => f.name !== 'sStartDateTime' || f.name !== 'sEndDateTime')
                const firDT = nfilters.find(f => f.name === 'sEndDateTime')
                firDT.value = ""
                setFilters([firDT, ...finrDT])
                setSearchData(prevData => ({
                    ...prevData,
                    sEndDateTime: null
                }))
                break;
            case "sEndDateTime":
                if (searchData["sTitle"] && searchData["sTitle"].trim() !== '')
                    filteredData = filteredData.filter(u => u.name.toLowerCase().includes(searchData["sTitle"].trim().toLowerCase()))
                if (searchData["sGroup"] !== '' && searchData["sGroup"] >= 0)
                    filteredData = filteredData.filter(u => u.idGroup === searchData["sGroup"])
                if (searchData["sLocation"] !== '' && searchData["sLocation"] >= 0)
                    filteredData = filteredData.filter(u => u.idMerchant === searchData["sLocation"])
                if (searchData["sStartDateTime"])
                    filteredData = filteredData.filter(u => +new Date(u.dateTimeStart) >= +new Date(searchData["sStartDateTime"]))
                break;
            default: break;
        }
        //#endregion

        //#region clear filter
        const filterItemNotToRemove = nfilters.filter(f => f.name !== name)
        const filterItemToRemove = nfilters.find(f => f.name === name)
        filterItemToRemove.value = ""
        setFilters([filterItemToRemove, ...filterItemNotToRemove])
        //#endregion

        setSearchData(prevData => ({
            ...prevData,
            [name]: ['sStartDateTime', 'sEndDateTime'].includes(name) ? null : ''
        }))
        setPromotions(filteredData)
    }
    const resetFilterData = (nfilters) => {
        nfilters && setFilters(nfilters.map(item => ({ ...item, value: '' })))
        setSearchData({
            sTitle: "",
            sGroup: '',
            sLocation: '',
            sStartDateTime: null,
            sEndDateTime: null
        })
        getAllPromotions()
    }
    const getAllPromotions = () => {
        setIsLoading(true)
        axios.get(promotionsEndPoints.getAll,
            { headers: { 'Authorization': authToken } })
            .then(res => {
                if (res.data.success) {
                    const { data } = res.data
                    setPromotions(data)
                    setSearchPromotions(data)
                }
            })
            .catch(err => err)
            .finally(() => setIsLoading(false))
    }
    const actions = [
        rowData => ({
            icon: rowData.status ? tableIcons.CheckBox : tableIcons.CheckBoxBlank,
            tooltip: promotionPermission.update ? rowData.status ? 'Deactivate this Promotion' : 'Activate this Promotion' : 'Permission Denied',
            disabled: !promotionPermission.update,
            onClick: (event, rowData) => new Promise((resolve) => {
                let cnfDesc = rowData.status ? `This will deactivate promotion ${rowData.title}` :
                    `This will activate promotion ${rowData.title}`
                confirm({ description: cnfDesc })
                    .then(() => {
                        let url = rowData.status ? promotionsEndPoints.deActivatePromotionById : promotionsEndPoints.activatePromotionById
                        axios.patch(
                            format(url, rowData.idPromotion),
                            {},
                            { headers: { 'Authorization': authToken } })
                            .then(res => {
                                if (res.data.success) {
                                    resetFilterData()
                                    resolve()
                                }
                            })
                    })
            })
        }),
        {
            icon: tableIcons.Edit,
            tooltip: promotionPermission.update ? 'Edit Promotion' : 'Permission Denied',
            disabled: !promotionPermission.update,
            onClick: (event, rowData) => new Promise((resolve) => {
                setIsLoading(true)
                setModalFormResetKeys([])
                let url = format(promotionsEndPoints.getPromotionById, rowData.idPromotion)
                axios.get(url,
                    { headers: { 'Authorization': authToken } })
                    .then(res => {
                        if (res.data.success) {
                            const { data } = res.data
                            resolve(data)
                        }
                    })
                    .catch(err => err)
                    .finally(() => setIsLoading(false))
            }).then(data => handleActionClick(event, true, data))
        }
    ]
    const handleSearchValueChange = (name, value) => {
        if (name === 'sStartDateTime') {
            MinEndDateTime = value
            isEndDateTimeDisabled = value ? false : true
            setSearchData(prevData => ({
                ...prevData,
                [name]: value,
                sEndDateTime: null
            }))
        }
        else if (name === 'sEndDateTime') {
            let endDateTime = new Date(Math.max(value, searchData.sStartDateTime))
            setSearchData(prevData => ({
                ...prevData,
                [name]: endDateTime
            }))
        }
        else {
            setSearchData(prevData => ({
                ...prevData,
                [name]: value
            }))
        }
    }
    const handleSearch = () => {
        setFilters([
            {
                name: "sTitle",
                value: searchData["sTitle"],
                remove: clearFilter
            },
            {
                name: "sGroup",
                value: searchData["sGroup"] === '' ? '' : searchGroupsMenus.find(g => g.val === searchData["sGroup"]).text,
                remove: clearFilter
            },
            {
                name: "sLocation",
                value: searchData["sLocation"] === '' ? '' : searchLocationMenus.find(l => l.val === searchData["sLocation"]).text,
                remove: clearFilter
            },
            {
                name: "sStartDateTime",
                value: searchData["sStartDateTime"] ? searchData["sStartDateTime"].toLocaleDateString() : '',
                remove: clearFilter
            },
            {
                name: "sEndDateTime",
                value: searchData["sEndDateTime"] ? searchData["sEndDateTime"].toLocaleDateString() : '',
                remove: clearFilter
            },
            {
                name: "clear",
                isClearAll: true,
                clearAll: resetFilterData
            }
        ])
        let filteredData = spromotions
        if ((searchData["sTitle"].trim() === '') &&
            (searchData["sGroup"] === '' || searchData["sGroup"] < 0) &&
            (searchData["sLocation"] === '' || searchData["sLocation"] < 0) &&
            (searchData["sStartDateTime"] === null) &&
            (searchData["sEndDateTime"] === null))
            resetFilterData(filters)
        else {
            if (searchData["sTitle"] && searchData["sTitle"].trim() !== '')
                filteredData = filteredData.filter(u => u.title?.toLowerCase().includes(searchData["sTitle"].trim().toLowerCase()))
            if (searchData["sGroup"] !== '' && searchData["sGroup"] >= 0)
                filteredData = filteredData.filter(u => u.idGroup === searchData["sGroup"])
            if (searchData["sLocation"] !== '' && searchData["sLocation"] >= 0)
                filteredData = filteredData.filter(u => u.idMerchant === searchData["sLocation"])
            if (searchData["sStartDateTime"])
                filteredData = filteredData.filter(u => +new Date(u.dateTimeStart) >= +new Date(searchData["sStartDateTime"]))
            if (searchData["sEndDateTime"])
                filteredData = filteredData.filter(u => +new Date(u.dateTimeEnd) <= +new Date(searchData["sEndDateTime"]))
            setPromotions(filteredData)
        }
    }
    const searchOptions = {
        title: Strings.SEARCH_PROMOTIONS_TITLE,
        spacing: 1,
        searchItems: [
            {
                name: "sTitle",
                label: Strings.TITLE,
                type: 'search',
                defaultValue: searchData["sTitle"],
                onChange: handleSearchValueChange
            },
            {
                name: "sGroup",
                label: Strings.SEARCH_CASINO_GROUP,
                isSelect: true,
                menuItems: searchGroupsMenus,
                defaultValue: searchData["sGroup"],
                onChange: handleSearchValueChange
            },
            {
                name: "sLocation",
                label: Strings.SEARCH_CASINO_LOCATION,
                isSelect: true,
                menuItems: searchLocationMenus,
                defaultValue: searchData["sLocation"],
                onChange: handleSearchValueChange
            },
            {
                name: "sStartDateTime",
                label: Strings.START_DATE_TIME_LABEL,
                type: "datetime",
                minDate: new Date('1900-01-01'),
                defaultValue: searchData["sStartDateTime"],
                onChange: handleSearchValueChange
            },
            {
                name: "sEndDateTime",
                label: Strings.END_DATE_TIME_LABEL,
                type: "datetime",
                isDisable: isEndDateTimeDisabled,
                minDate: MinEndDateTime,
                defaultValue: isEndDateTimeDisabled ? null : searchData["sEndDateTime"],
                onChange: handleSearchValueChange
            }
        ],
        handleSearch
    }
    const detailPanel = [
        {
            icon: tableIcons.ZoomIn,
            openIcon: tableIcons.ZoomOut,
            tooltip: 'view details',
            render: rowData => {
                return (
                    <Box className={classes.promoDetailBox}>
                        <Paper elevation={0} className={classes.promoDetailPaper}>
                            <Grid container spacing={4} alignItems="center" justify="space-evenly">
                                <Grid item>
                                    <img src={rowData.imageUrl} alt="" onError={(e) => e.target.src = '../img/noImage.jpg'} />
                                </Grid>
                                <Grid item md={12} lg={8}>
                                    <Typography variant="h6">Description:</Typography>
                                    <Typography variant="body2" component="p">
                                        {rowData.description}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Box>
                )
            },
        }
    ]
    //#region Modal
    useEffect(() => {
        new Promise(resolve => {
            setModalFormResetKeys(["IdMerchant"])
            resolve()
        }).then(() =>
            setModalContent(prevContent => ({
                ...prevContent,
                IdMerchant: {
                    ...prevContent["IdMerchant"],
                    menuItems: locationMenus
                }
            }))
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [locationMenus])
    const handleActionClick = async (event, isEdit = false, rowData = {}) => {
        let promotionUploadedImage = rowData.imageUrl && validURL.isUri(rowData.imageUrl) ? [rowData.imageUrl] : []

        // Al CREAR, Start Date arranca en hoy a las 00:00 para que el usuario solo capture el End.
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        const defaultStart = isEdit ? (rowData.dateTimeStart ?? null) : today
        ChosenStartDateTime = defaultStart

        setModalHeader({
            isForm: true,
            title: isEdit === true ? "Edit Promotion" : "Add Promotion",
            header: isEdit === true ? "Edit this existing Promotion" : "Create a new Promotion",
            modalWidth: 'md'
        })
        let modalContentObj = {
            Title: {
                label: "Promotion Title",
                size: "small",
                variant: "outlined",
                col: 12,
                value: rowData.title ?? "",
                validator: {
                    required: { value: true, message: "Promotion Title is required" }
                }
            },
            IdGroup: {
                label: "Group",
                type: 'select',
                size: "small",
                variant: "outlined",
                col: 6,
                value: rowData.idGroup ?? '',
                menuItems: groupsMenus,
                validator: {
                    required: { value: true, message: "Please choose a Group" }
                },
                onSelectionChange: handleSelectionChange
            },
            IdMerchant: {
                label: "Location",
                type: 'select',
                size: "small",
                variant: "outlined",
                col: 6,
                value: rowData.idMerchant ?? '',
                menuItems: locationMenus,
                validator: {
                    required: { value: true, message: "Please choose a Location" }
                }
            },
            Description: {
                label: "Description",
                size: "small",
                variant: "outlined",
                col: 12,
                value: rowData.description ?? "",
                validator: {
                    required: { value: true, message: "Description is required" }
                }
            },
            PromoStartDateTime: {
                label: "Start Date and Time",
                type: "datetime",
                size: "small",
                variant: "outlined",
                col: 6,
                value: defaultStart,
                minDate: new Date('1900-01-01 00:00:00'),
                onChange: handleDateChange,
                validator: {
                    required: { value: true, message: "Promotion Start Date and Time is required" }
                }
            },
            PromoEndDateTime: {
                label: "End Date and Time",
                type: "datetime",
                size: "small",
                variant: "outlined",
                col: 6,
                value: rowData.dateTimeEnd ?? null,
                minDate: defaultStart,
                onChange: handleDateChange,
                disabled: !defaultStart && true,
                validator: {
                    required: { value: true, message: "Promotion End Date and Time is required" }
                }
            },
            Priority: {
                label: "Priority",
                // El valor almacenado/enviado es la prioridad real (0 = más prioridad,
                // 100 = menos). El slider se muestra invertido: izquierda "Less" (100),
                // derecha "More" (0), en 5 pasos.
                value: rowData.priority ?? 0,
                type: 'slider',
                invert: true,
                min: 0,
                max: 100,
                step: 25,
                marks: [
                    { value: 0, label: 'Less' },
                    { value: 25, label: '' },
                    { value: 50, label: '' },
                    { value: 75, label: '' },
                    { value: 100, label: 'More' },
                ],
                col: 12,
            },
            Image: {
                label: "image",
                type: 'image',
                value: promotionUploadedImage,
                col: 12,
                dropzoneOptions: {
                    acceptedFiles: ['image/png'],
                    maxFileSize: 2 * Math.pow(1024, 2), //MB to B
                    filesLimit: 1
                },
                validator: {
                    required: { value: true, message: "Please upload an image of type .png" }
                }
            }
        }
        if (isEdit === false) {
            modalContentObj = {
                PushNotification: {
                    label: "Send Push Notification",
                    value: true,
                    type: 'switch',
                    col: 12,
                    justify: 'flex-end'
                },
                ...modalContentObj
            }
        }
        setModalContent(modalContentObj)
        setModalActions([
            {
                label: isEdit === true ? "Update" : "Save",
                icon: isEdit === true ? tableIcons.Edit : tableIcons.Save,
                isSubmit: true,
                action: isEdit === true ? (data) => handleSubmit(data, true, rowData) : (data) => handleSubmit(data, false)
            }
        ])
        setOpenDialog(true)
        if (isEdit === true) {
            setGLObj(prevGl => ({
                ...prevGl,
                group: rowData.idGroup,
                location: rowData.idMerchant
            }))
        }
        else setModalFormResetKeys([])
    }

    const handleSelectionChange = (event) => {
        setGLObj(prevGL => ({
            ...prevGL,
            group: event.target.value
        }))
        new Promise(resolve => {
            setModalFormResetKeys(["IdMerchant"])
            resolve()
        }).then(() =>
            setModalContent(prevContent => ({
                ...prevContent,
                IdMerchant: {
                    ...prevContent["IdMerchant"],
                    value: '',
                    menuItems: locationMenus
                }
            }))
        )
    }
    const handleDateChange = (name, changedDate) => {
        if (name === "PromoEndDateTime") {
            // Solo se debe resetear el propio End Date; sin esto, un modalFormResetKeys
            // heredado (p.ej. ["IdMerchant"] tras elegir grupo) borraba la ubicación.
            new Promise(resolve => {
                setModalFormResetKeys(["PromoEndDateTime"])
                resolve()
            }).then(() =>
                setModalContent(prevContent => ({
                    ...prevContent,
                    PromoEndDateTime: {
                        ...prevContent["PromoEndDateTime"],
                        value: new Date(Math.max(ChosenStartDateTime, changedDate))
                    }
                }))
            )
        }
        else {
            new Promise(resolve => {
                ChosenStartDateTime = changedDate
                setModalFormResetKeys(["PromoEndDateTime"])
                resolve()
            }).then(() =>
                setModalContent(prevContent => ({
                    ...prevContent,
                    PromoEndDateTime: {
                        ...prevContent["PromoEndDateTime"],
                        value: null,
                        minDate: changedDate,
                        disabled: changedDate ? false : true
                    }
                }))
            )
        }
    }
    const handleSubmit = async (data, isEdit, rowData) => {
        const { Title, IdGroup, IdMerchant, Description, PromoStartDateTime, PromoEndDateTime, Priority, Image, PushNotification } = data

        // Al CREAR con push activado y sin grupo NI ubicación (ambos "No ..." = 0),
        // el push llega a TODO el ecosistema: pedir confirmación antes de enviar.
        const isWholeEcosystemPush = isEdit === false
            && PushNotification === true
            && Number(IdGroup) === 0
            && Number(IdMerchant) === 0
        if (isWholeEcosystemPush) {
            try {
                await confirm({
                    title: 'Confirm',
                    description: 'A push notification will be sent to all the ecosystem, please confirm.',
                    confirmationText: 'Accept',
                    cancellationText: 'Cancel'
                })
            } catch (e) {
                // El usuario dio Cancel: no se hace submit, regresa al modal.
                return
            }
        }

        const imageFileInBase64 = Image && await toBase64(Image[0])
        const dataObj = {
            "idPromotion": isEdit && rowData.idPromotion,
            "idGroup": IdGroup,
            "idMerchant": IdMerchant,
            "title": Title,
            "description": Description,
            "image": imageFileInBase64,
            "dateTimeStart": PromoStartDateTime ?? "",
            "dateTimeEnd": PromoEndDateTime ?? "",
            "priority": Priority,
            "status": true
        }
        if (isEdit === false) dataObj.pushNotification = PushNotification ?? false
        setModalTaskRunning(true)
        axios({
            method: isEdit === true ? 'put' : 'post',
            url: promotionsEndPoints.updatePromotion,
            headers: { 'Authorization': authToken },
            data: dataObj
        })
            .then((res) => {
                const response = res.data
                if (response.success === true) {
                    handleModalClose()
                    resetFilterData()
                }
                else
                    setModalFormError(response.errors)
            })
            .catch(err => err)
            .finally(() => setModalTaskRunning(false))
    }

    const handleModalClose = () => {
        setOpenDialog(false)
        setModalFormError({})
        setGLObj({
            program: '',
            group: '',
            location: ''
        })
        setModalFormResetKeys([])
    }
    return {
        promotions,
        groupsMenus,
        actions,
        detailPanel,
        isLoading,
        openDialog,
        filters,
        searchData,
        getAllPromotions,
        searchOptions,
        handleModalClose,
        handleActionClick,
        modalHeader,
        modalContent,
        modalActions,
        modalFormResetKeys,
        modalTaskRunning,
        modalFormError,
        promotionPermission
    }
}

export default usePromotions